import React from 'react';
import styled from 'styled-components';
import { Heading, TextLg, Text } from '@atoms';
import { Link } from "gatsby";
import { theme } from '@theme';
import { wordTime } from '@utils/wordTime';
import cardPlaceholderImg from './card-placeholder.jpg';
import { Container, CardContainer } from "./styles/TextOnHoverCard.styled"
import { InlineLink } from '../Resources/ResourceCardInlineLink';
import OptimizedImage from '../../utils/optimizedImage';

export const TextOnHoverCard = ({ title, alternateTitle, categories, description, author, link, featuredImg, gatsbyImage, border, blogBody, alt }) => {
  const category = categories && categories[0]?.title.toLowerCase();
  return (
    <Container>
      <CardContainer
        data-comp={TextOnHoverCard.displayName}
        theme={theme}
        border={border}
      >
        <OptimizedImage 
          image={gatsbyImage}
          src={featuredImg || cardPlaceholderImg} 
          alt={alt || title}
        />
        {title && 
          <Heading 
            headingSize='H6'
            style={{
              marginBottom: '8px',
              textAlign: 'center',
              margin: 'auto'
            }}
            className="line-clamp-2"
            >
            {title}
          </Heading>
        }
      </CardContainer>
      <div className="overlay">
        { description && 
          <div  className="text">
            <Heading 
              headingSize='H6'
              style={{
                marginBottom: '8px',
                textAlign: 'center',
                margin: 'auto',
                color: 'white'
              }}
              className="line-clamp-2"
            >
              {alternateTitle || title}
            </Heading>
            <Text style={{color: 'white', padding: '16px 0'}}>{description}</Text> 
            {categories && 
              <InlineLink category={category} to={link}/>
            }
            {!categories &&
              <Link style={{ display: 'block', color: 'white' }} to={link}>Learn More</Link>
            }
          </div>
        }
      </div>
    </Container>
  );
};

TextOnHoverCard.displayName = 'Card with Hover Text';
